import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const searchUserSupplierNegotiation = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/user-supplier-negotiation/search`,
    data,
  );
  return response.data;
};

export const createUserSupplierNegotiation = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/user-supplier-negotiation`,
    data,
  );
  return response.data;
};

export const updateUserSupplierNegotiation = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/user-supplier-negotiation`,
    data,
  );
  return response.data;
};

export const searchUserSupplierNegotiationApprovals = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/user-supplier-negotiation/approval-search`,
    data,
  );
  return response.data;
};

export const userSupplierNegotiationAdvancedSearch= async(data)=>{
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/user-supplier-negotiation/advanced-search`,
    data,
  );
  return response.data;
}

export const userSupplierNegotiationApproval = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/user-supplier-negotiation/approval`,
    data,
  );
  return response.data;
};

export const supplierNegotiationApprovalQtyEdit = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/user-supplier-negotiation/approval/qty`,
    data,
  );
  return response.data;
};

export const supplierNegotiationApprovalAmountEdit = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/user-supplier-negotiation/approval/amount`,
    data,
  );
  return response.data;
};
